import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";


import mission01 from "../assets/content/main/mission-01.png"
import mission02 from "../assets/content/main/mission-02.png"	
import mission03 from "../assets/content/main/mission-03.png"


gsap.registerPlugin(ScrollTrigger);



export default function MissionsSection() {
const containerRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {

      
    const sectionMissions = document.querySelector(".section--missions");
    const sectionMissionsContents = document.querySelector(".missions");
    const missionText = document.querySelector(".missions__txt");
    const missionBg = document.querySelector(".missions__bg");
    const missionTextItems = missionText.querySelectorAll(".mission");
    const missionItems = document.querySelectorAll(".mission");
    const missionImgs =  document.querySelectorAll(".mission__img");


      
      // =========================
      // Background Pin Animation
      // =========================
      const missionBackground = gsap.timeline({
        scrollTrigger: {
          trigger: ".section--missions",
          start: "top top",
          end: "+=250%",
          scrub: true,
          pin: ".missions__bg",
          anticipatePin: 1,
          // markers: true,
        },
      });

      missionBackground.to(".mission__img.mission1", {
        opacity: 0,
        scale: 1.2,
        duration: 1,
      });

      missionBackground.fromTo(
        ".mission__img.mission2",
        {
          opacity: 0,
          scale: 1,
        },
        {
          opacity: 1,
          scale: 1.1,
          duration: 1,
        },
        0.5
      );

      missionBackground.to(
        ".mission__img.mission2",
        {
          opacity: 0,
          scale: 1.2,
          duration: 1,
        },
        1
      );

      missionBackground.fromTo(
        ".mission__img.mission3",
        {
          opacity: 0,
          scale: 1,
        },
        {
          opacity: 1,
          scale: 1.2,
          duration: 1,
        },
        1.5
      );

      // =========================
      // Text Animation
      // =========================
      gsap.fromTo(
        ".missions__txt .mission",
        {
          y: 100,
          opacity: 0,
        },
        {
          y: 0,
          opacity: 1,
          stagger: 0.3,
          ease: "none",
          scrollTrigger: {
            trigger: ".section--missions",
            start: "top center",
            end: "bottom center",
            scrub: true,
            // markers: true,
          },
        }
      );


    // ==================================================
    // SECTION INTRO ANIMATION
    // ==================================================

    
    gsap.timeline({
    scrollTrigger: {
        trigger: sectionMissions,
        scrub: true,
        start: "top bottom",
        end: "top top",
        onUpdate: (self) => {
          const d = self.progress;
          sectionMissions.style.width = 78 + d * 22 + "%";
        const img = missionBg.querySelector("#missionfirst");
          if (img) img.style.transform = `translate(-50%,-50%) scale(${1.5})`;
          missionText.style.opacity = d;
        },
      },
    });

    // ==================================================
    // TEXT INDEX CHANGE
    // ==================================================
    gsap.timeline({
      scrollTrigger: {
        trigger: missionText,
        // scrub: true,
        start: "top bottom",
        end: "bottom bottom",

        // onUpdate: (self) => {
        //   const degree = self.progress * 10;
        //   const idx = Math.floor(
        //     degree / missionTextItems.length
        //   );

        //   missionBg.dataset.idx = idx;
        //   missionText.dataset.idx = idx;
        // },

      },
    });




    // ==================================================
    // SECTION EXIT ANIMATION
    // ==================================================
    // gsap.timeline({
    //   scrollTrigger: {
    //     trigger: missionText,
    //     scrub: true,
    //     start: "bottom bottom",
    //     end: "bottom top",

    //     onUpdate: (self) => {
    //       const degree = self.progress;
    //       sectionMissionsContents.style.opacity =
    //         1 - degree * 0.7;
    //       sectionMissionsContents.style.transform =
    //         `translate(0, ${degree * 10}%)`;
    //     },
    //   },
    // });



    // let previousMissionIndex = 0;

    // =========================================
    // INITIAL ACTIVE STATE
    // =========================================
    // document
    //   .querySelector(".mission.item1")
    //   ?.classList.add("active");

    // document
    //   .querySelector(".mission__img.item1")
    //   ?.classList.add("active");

    // =========================================
    // INTERSECTION OBSERVER
    // =========================================
    // const options = {
    //   threshold: 0.5,
    // };

    // const observer = new IntersectionObserver(
    //   (entries) => {

    //     entries.forEach((entry) => {

    //       if (entry.isIntersecting) {

    //         const activeClass = "active";

    //         const currentMission = entry.target;

    //         const currentMissionIndex =
    //           Array.from(missionItems).indexOf(
    //             currentMission
    //           );

    //         // =========================================
    //         // SCROLL DOWN
    //         // =========================================
    //         if (
    //           currentMissionIndex >
    //           previousMissionIndex
    //         ) {

    //           missionItems[
    //             previousMissionIndex
    //           ]?.classList.remove(activeClass);

    //           missionImgs[
    //             previousMissionIndex
    //           ]?.classList.remove(activeClass);

    //           for (
    //             let i = previousMissionIndex + 1;
    //             i <= currentMissionIndex;
    //             i++
    //           ) {
    //             missionItems[i]?.classList.add(
    //               activeClass
    //             );

    //             missionImgs[i]?.classList.add(
    //               activeClass
    //             );
    //           }

    //         // =========================================
    //         // SCROLL UP
    //         // =========================================
    //         } else if (
    //           currentMissionIndex <
    //           previousMissionIndex
    //         ) {

    //           missionItems[
    //             currentMissionIndex + 1
    //           ]?.classList.remove(activeClass);

    //           missionImgs[
    //             currentMissionIndex + 1
    //           ]?.classList.remove(activeClass);

    //           for (
    //             let i = previousMissionIndex - 1;
    //             i >= currentMissionIndex;
    //             i--
    //           ) {
    //             missionItems[i]?.classList.add(
    //               activeClass
    //             );

    //             missionImgs[i]?.classList.add(
    //               activeClass
    //             );
    //           }
    //         }

    //         previousMissionIndex =
    //           currentMissionIndex;
    //       }
    //     });

    //   },
    //   options
    // );

    // // =========================================
    // // OBSERVE ITEMS
    // // =========================================
    // missionItems.forEach((item) => {
    //   observer.observe(item);
    // });

    }, containerRef);

    return () => ctx.revert();
  }, []);


  return (
    <div ref={containerRef}>  
     <section className="section section--missions"  id="missions" >
					<div className="missions">
              <div className="missions__bg" data-idx="0">
							<img src={mission01} alt="" className="mission__img mission0 mission1" id="missionfirst"/>
							<img src={mission02} alt="" className="mission__img mission2"/>
							<img src={mission03} alt="" className="mission__img mission3"/>
						</div>
						<div className="container">
							<div className="row">
								<div className="col-7 col-offset-7">
										<div className="missions__txt-motion">
											<ul className="missions__txt" data-idx="0">
												<li className="mission mission1">
													<h4 className="mission__head headline-4-kr trn" data-trn-key="index-02">Empowered Vision.<br/>Embedded Values.</h4>
													<a  href="/protect" className="bttn bttn-txt--circle" size="l" color="white"><span className="txt" data-txt="ABOUT OUR HERITAGE">ABOUT OUR HERITAGE</span><span className="icon"></span></a>
												</li>
												<li className="mission mission2">
													<h4 className="mission__head headline-4-kr trn" data-trn-key="index-03"> Advanced Avionics Solutions <br/>for smarter, safer, and highly <br/>efficient systems</h4>
													<a href="/sustainable-tech" className="bttn bttn-txt--circle" size="l" color="white"><span className="txt" data-txt="SEXPLORE SOLUTIONS">SEXPLORE SOLUTIONS</span><span className="icon"></span></a>
												</li>
												<li className="mission mission3">
													<h4 className="mission__head headline-4-kr trn" data-trn-key="index-04">Precise Time & Frequency <br/>Solutions where every<br/> second matters </h4>
													<a href="/discover" className="bttn bttn-txt--circle" size="l" color="white"><span className="txt" data-txt="VIEW TECHNICAL SPECS">VIEW TECHNICAL SPECS</span><span className="icon"></span></a>
												</li>
											</ul>
										</div>
								</div>
							</div>
						</div>
					</div>
				</section>
      </div>
   
  );
}
